<div class="models-editor">
  <app-models-schema-detail
    *ngIf="selectedSchema"
    [schemaId]="selectedSchema.id"
    [schemaName]="selectedSchema.name"
    (back)="closeSchema()">
  </app-models-schema-detail>

  <app-models-unit-set-detail
    *ngIf="!selectedSchema && selectedUnitSet"
    [unitSetId]="selectedUnitSet.id"
    [unitSetName]="selectedUnitSet.name"
    (back)="closeUnitSet()">
  </app-models-unit-set-detail>

  <mat-tab-group *ngIf="!selectedSchema && !selectedUnitSet" class="models-editor__tabs">
    <mat-tab label="Schemas">
      <p class="models-editor__hint">Right-click a schema to manage its tables and foreign keys.</p>
      <wc-grid
        gridKey="modelsSchemas"
        [showQuickSearch]="true"
        [contextMenuItems]="schemaRowActions"
        (contextMenuAction)="openSchema($event)">
      </wc-grid>
    </mat-tab>

    <mat-tab label="Unit Sets">
      <p class="models-editor__hint">Right-click a unit set to edit its units.</p>
      <wc-grid
        gridKey="modelsUnitSets"
        [showQuickSearch]="true"
        [contextMenuItems]="unitSetRowActions"
        (contextMenuAction)="openUnitSet($event)">
      </wc-grid>
    </mat-tab>
  </mat-tab-group>
</div>
